import { Link, styled } from "@mui/material";

export const StyledLinkGreyHoverBlue = styled(Link)({
    textDecoration: "none",
    cursor: "pointer",
    color: "#ffffff99",

    "& .MuiLink-root": {
        textDecoration: "none",
        color: "#ffffff99"
    },

    "&:hover": {
        color: "#006EFF",

        "& .MuiLink-root": {
            color: "#006EFF"
        }
    },
    "&.active": {
        color: "#006EFF"
    }
})

export const StyledLinkFooter = styled(Link)({
    display: "flex",
    gap: "4px",
    fontSize: "14px",
    fontWeight: 700,
    textDecoration: "none",
    cursor: "pointer",
    color: "#ffffff99",
    paddingRight: "12px",
    borderRight: "1px solid #ffffff1a",
    "@media (max-width:1200px)": {
        borderRight: "none",
    },
    "&:hover": {
        fontSize: "14px",
        color: "#006EFF"
    },
    "&.open": {
        color: "#006EFF"
    },
})

export const StyledLinkGreyNoHover = styled(Link)({
    textDecoration:"none",
    color: "#ffffff99",
    "&:hover": {    
        color: "#ffffff99"
    },
})

export const StyledLinkBlue = styled(Link)({
    textDecoration: "none",
    color: "#006EFF",
    "&:hover": {    
        color: "#006EFF"
    },
})

export const StyledLink = styled(Link)({
    textDecoration: "none"
})